import { useCallback } from 'react';

import { useDistributorForRegType } from '@interlayer/js/app/components/main/Registration/hooks/useDistributorForRegType';
import { useGtmEvent } from '@interlayer/js/app/hooks/analiticsSubscribe';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';

enum GTM_REG_TYPE {
    registration = 'registration',
    upgrade = 'upgradeAccount',
    retailReg = 'retailReg',
    retailUpgrade = 'retailUpgrade',
    slotReg = 'slotReg',
    slotUpgrade = 'slotUpgrade'
}

export const useGtmEventReg = () => {
    const gtmEvent = useGtmEvent();
    const regType = useDistributorForRegType(GTM_REG_TYPE);
    const {
        attemptId,
        lastFieldName,
        registrationNameStep,
        additionalUpgradeData: { phase }
    } = useRegistrationSelector();

    return useCallback((eventName: string, additionalData?: Record<string, string>) => {
        gtmEvent(eventName, {
            phase,
            id: attemptId,
            type: regType,
            lastField: lastFieldName,
            step: registrationNameStep,
            ...additionalData && { additionalData }
        });
    }, [attemptId, gtmEvent, lastFieldName, phase, regType, registrationNameStep]);
};
